import { ReactNode } from 'react';
import styled from 'styled-components';

export const MenubarTrigger = ({
  children,
  key,
  onClick,
  onMouseEnter,
  isActive,
  isDisabled,
  isDimmed,
  cursorPointer,
}: {
  children: ReactNode;
  key?: string;
  onClick?: () => void;
  onMouseEnter?: () => void;
  isActive?: boolean;
  isDisabled?: boolean;
  isDimmed?: boolean;
  cursorPointer?: boolean;
}) => {
  return (
    <Container
      $isActive={isActive}
      $isDisabled={isDisabled}
      $isDimmed={isDimmed}
      $cursorPointer={cursorPointer}
      key={key}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
    >
      {children}
    </Container>
  );
};

const Container = styled.div<{
  $isActive?: boolean;
  $isDisabled?: boolean;
  $isDimmed?: boolean;
  $cursorPointer?: boolean;
}>`
  ${({ $cursorPointer }) => $cursorPointer && `cursor: pointer;`}
  padding: 5px 10px;

  background-color: var(--neutral-2);
  color: var(--main-2);
  border-radius: var(--radius-2);

  transition:
    background-color 0.3s ease,
    color 0.3s ease,
    opacity 0.3s ease;

  &:hover {
    background-color: var(--neutral-3);
    color: var(--main-1);
  }

  ${({ $isActive }) =>
    $isActive &&
    `
    background-color: var(--neutral-3);
    color: var(--main-1);
    &:hover {
      background-color: var(--neutral-3);
      color: var(--main-1);
    }
  `}

  ${({ $isDisabled }) =>
    $isDisabled &&
    `
    opacity: 0.5;
    pointer-events: none;
  `}

  ${({ $isDimmed }) =>
    $isDimmed &&
    `
    opacity: 0.5;
  `}
`;
